import { formatTime, formatDate } from './actionUtils';

export const checkMessageObject = (
  messageOrObject: any,
  objectPropertyContainingMessage: any,
  intl: any
) => {
  let message: any = '';

  if (
    typeof messageOrObject === 'string' ||
    typeof messageOrObject === 'number'
  ) {
    message = messageOrObject as string;
  } else {
    message = (messageOrObject as Record<string, any>)[
      objectPropertyContainingMessage
    ];

    const messagetype = message
      ? (messageOrObject as Record<string, any>)['type']
      : undefined;
    if (messagetype === 'date') {
      message = formatDate(message, intl.locale);
    } else if (messagetype === 'time') {
      message = formatTime(message, intl.locale);
    } else if (message instanceof Date) {
      message = undefined;
    }
  }

  return message;
};
